import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  TabLayout,
} from '#components/layouts/TabLayout';
import {
  TabsGroup,
  type TabProps,
} from '#src/components/ui/nav/TabsGroup';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout',
)({
  // component: ScoutLayout,
  component: RouteComponent,
  beforeLoad: () => {
    const adminLinks: TabProps[] = [
      {
        label: 'Settings',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/gary/settings',
        },
        hidden: (context) => {
          if (context?.auth?.user?.profile?.groups) {
            return !((context.auth.user.profile.groups as string[]).includes('client-admin'));
          }
          return false;
        },
      },
    ];
    const defaultLinks: TabProps[] = [
      {
        label: 'About',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/gary/about',
        },
      },
      {
        label: 'Workpapers',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/gary/workpapers',
        },
      },
      {
        label: 'Clients',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/gary/clients',
        },
      },
    ];
    return {
      crumb: {
        label: 'Gary',
        href: '/about',
      },
      header: (
        <>
          <TabsGroup
            tabs={ defaultLinks.concat(adminLinks) }
            defaultTabIndex={ 0 }
          />
        </>
      ),
    };
  },
});

function RouteComponent(): React.ReactNode {
  return (
    <>
      <TabLayout
      // tabs={ userIsClientAdmin ? defaultLinks.concat(adminLinks) : defaultLinks }
      />
    </>
  );
}
